import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { openDialog } from '../../../base/dialog/actions';
import { IconUsers } from '../../../base/icons/svg';
import Label from '../../../base/label/components/web/Label';
import { COLORS } from '../../../base/label/constants';
import { getParticipantCount } from '../../../base/participants/functions';
import SpeakerStats from '../../../speaker-stats/components/web/SpeakerStats';
import { isSpeakerStatsDisabled } from '../../../speaker-stats/functions';
import { iAmVisitor } from '../../../visitors/functions';
const useStyles = makeStyles()(theme => {
    return {
        speakerStatsLable: {
            height: '34px !important',
            borderRadius: 0
        },
    };
});
/**
 * ParticipantsCount react component.
 * Displays the number of participants and opens Speaker stats on click.
 *
 * @class ParticipantsCount
 */
function SpeakerStatsLabel() {
    const conference = useSelector((state) => state['features/base/conference'].conference);
    let count = useSelector(getParticipantCount);
    const iAmVisitorState = useSelector(iAmVisitor);
    const _isSpeakerStatsDisabled = useSelector(isSpeakerStatsDisabled);
    const dispatch = useDispatch();
    const { classes: styles } = useStyles();
    // visitor has hidden its own video and should not count itself
    if (iAmVisitorState) {
        count--;
    }
    const onClick = () => {
        dispatch(openDialog(SpeakerStats, { conference }));
    };
    if (count <= 1 || _isSpeakerStatsDisabled) {
        return null;
    }
    return (React.createElement(Label, { color: COLORS.white, icon: IconUsers, iconColor: '#fff', 
        // eslint-disable-next-line react/jsx-no-bind
        onClick: onClick, text: `${count}`, className: styles.speakerStatsLable }));
}
export default SpeakerStatsLabel;
